import { PropsWithChildren } from 'react';
import ErrorPage from './error-page';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';

export const ErrorBoundary: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <ReactErrorBoundary fallback={<ErrorPage />}>{children}</ReactErrorBoundary>
  );
};
